import { render } from "./UserRoleComponent.vue?vue&type=template&id=70c4eab6"
import script from "./UserRoleComponent.vue?vue&type=script&lang=js"
export * from "./UserRoleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__